import React from 'react'
import Text from '../../../components/text'
import Flex from '../../../components/flex'
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <footer className="footer-wrapper">
            <div className="container">
                <Flex justifyContent="center" alignItemsCenter>
                    <div className="copyright-text">

                    © 2012-2023 Millennium Garages /

                    <a href="https://www.spplus.com" target="_blank">SP Plus Corporation</a>
                        <div>
                    <a  target="_blank" href="https://www.millenniumgarages.com/privacy-policy/">Privacy Policy</a> |
                    <a  target="_blank" href="https://www.millenniumgarages.com/terms-of-use/">Terms of Use</a> |
                    <a  target="_blank" href="https://ccpa.spplus.com" >California Consumer Privacy Policy Requests</a> |
                    <a
                     target="_blank" href="https://www.millenniumgarages.com/sp-plus-automated-license-plate-recognition-usage-and-privacy-policy/">Automated License
                    Plate Recognition Usage and Privacy Policy</a>
                        </div>
                    </div>

                </Flex>
            </div>
        </footer>
    )
}

export default Footer